module.exports = __webpack_public_path__ + "img/colilla.62766a66.png";